<!--
 * @Description: 
 * @LastEditors: wjx
 * @Date: 2020-11-14 17:08:35
-->

<template>
  <div class="search">
    <searchEl @search-input-enter="searchInputEnter"></searchEl>
    <div class="search-content">
      <record v-if="cname == 'record'" @search-input-enter="searchInputEnter"></record>
      <result v-else></result>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import searchEl from './components/searchEl.vue';
import record from './components/record.vue';
import result from './components/result.vue';

export default {
  name: '',
  data() {
    return {
      cname: 'record'
    };
  },
  watch: {
    $route(to, from) {
      if (from.name === 'home') {
        this.cname = 'record';
      }
    }
  },
  methods: {
    ...mapActions(['searchWordActions']),
    onCancel() {
      this.$router.go(-1);
    },
    onSearch() {},
    searchInputEnter() {
      this.cname = 'result';
    }
  },
  computed: {},
  components: {
    searchEl,
    record,
    result
  },
  created() {},
  activated() {},
  deactivated() {
    // 销毁时清空keyword
    this.searchWordActions('');
  },
  destroyed() {}
};
</script>

<style lang="less" scoped>
.search {
  &-content {
  }
}
</style>
